module.exports = __webpack_public_path__ + "static/media/nuxtJS.d4336459.svg";